var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"clickable",on:{"click":function($event){_vm.show = !_vm.show}}},[(!_vm.show)?_vm._t("normal-text"):_vm._e(),(_vm.show)?_vm._t("hidden-text"):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }